import React, {useState} from "react";
import {makeStyles} from "@material-ui/core";
import GridBlock from "components/GridBlock";
import Tr from "translations/Translations";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import Confirm from "components/popup/confirm/Confirm";
import HelpTooltip from "components/HelpTooltip";
import clsx from "clsx";
import PropTypes from "prop-types";
import {ContractorVerificationProcedureType, ContractorVerificationProcedureTypeLabel} from "constants/ContractorVerificationProcedureType";

const useStyles = makeStyles(theme => ({
    button: {
        width: 560,
    },
    help: {
        position: 'absolute',
        right: 70,
        color: theme.palette.text.button
    },
    helpNotSelected: {
        color: theme.palette.primary.main
    }
}));

function VerificationProcedureType(
    {
        className,
        contractorVerificationProcedure,
        handleProcedureChange,
        editable
    }) {

    const classes = useStyles();
    const [confirmOpened, setConfirmOpened] = useState(false);

    const handleProcedureChangeConfirm = () => {
        setConfirmOpened(false);
        handleProcedureChange(contractorVerificationProcedure.verificationProcedure === ContractorVerificationProcedureType.CLASSIC ?
            ContractorVerificationProcedureType.REVERSE : ContractorVerificationProcedureType.CLASSIC);
    };

    const handleToggleClick = (event, newProcedure) => {
        if (editable && newProcedure !== null) {
            setConfirmOpened(true)
        }
    };
    const proc = contractorVerificationProcedure.verificationProcedure;

    return (<GridBlock column className={className}>
            <GridBlock justify="center">
                <ToggleButtonGroup size="medium" value={proc} exclusive onChange={handleToggleClick}>
                    <ToggleButton classes={{root: classes.button}} value={ContractorVerificationProcedureType.CLASSIC} disabled={!editable}>
                        {ContractorVerificationProcedureTypeLabel(ContractorVerificationProcedureType.CLASSIC)}
                        <HelpTooltip className={clsx(classes.help, {[classes.helpNotSelected]: !(proc === ContractorVerificationProcedureType.CLASSIC)})}
                                     text={Tr('contractor_verification_classic_desc')}/>
                    </ToggleButton>
                    <ToggleButton classes={{root: classes.button}} value={ContractorVerificationProcedureType.REVERSE} disabled={!editable}>
                        {ContractorVerificationProcedureTypeLabel(ContractorVerificationProcedureType.REVERSE)}
                        <HelpTooltip className={clsx(classes.help, {[classes.helpNotSelected]: !(proc === ContractorVerificationProcedureType.REVERSE)})}
                                     text={Tr('contractor_verification_reverse_desc')}/>
                    </ToggleButton>
                </ToggleButtonGroup>
            </GridBlock>

            <Confirm
                open={Boolean(confirmOpened)}
                onConfirm={handleProcedureChangeConfirm}
                onCancel={() => setConfirmOpened(false)}
                confirmText="contractor_verification_procedure_change_confirm"
            />
        </GridBlock>
    )
}

VerificationProcedureType.propTypes = {
    contractorVerificationProcedure: PropTypes.shape({
        verificationProcedure: PropTypes.string
    }),
    handleProcedureChange: PropTypes.func,
    editable: PropTypes.bool
}

export default VerificationProcedureType;

